// ===================================================
// useGuestMigration.js — 게스트 기록 → 계정 이전 훅
//
// 역할:
//   - 비로그인(게스트) 상태에서 기록하다가 로그인하는 순간,
//     로컬에 저장된 게스트 기록을 Supabase DB로 자동 이전(마이그레이션)
//   - 이전 완료 후: 로컬 데이터 삭제 + 세션 목록 새로고침 + 토스트 메시지
// ===================================================

import { useEffect, useRef } from 'react';
import { getAllGuestSessionsFlat, deleteAllGuestSessions } from '../utils/guestStorage';
import { migrateGuestSession } from '../storage';

export function useGuestMigration({ user, refreshSessions, showToast, setShowAuth }) {
  // 이전 user 값 추적: null/false → 사용자 객체 변경 시 마이그레이션 트리거
  const prevUserRef = useRef(null);

  useEffect(() => {
    const prevUser = prevUserRef.current;
    prevUserRef.current = user;

    // user가 없거나, 이미 로그인 상태였으면 건너뜀 (처음 로그인한 경우만 실행)
    if (!user) return;
    if (prevUser && prevUser !== false) return;

    const guestSessions = getAllGuestSessionsFlat();
    if (guestSessions.length === 0) return;

    (async () => {
      try {
        for (const gs of guestSessions) {
          await migrateGuestSession(gs);
        }
        deleteAllGuestSessions();
        await refreshSessions(); // DB에서 최신 데이터 다시 로드
        showToast(`기록 ${guestSessions.length}개를 계정으로 옮겼어요`);
        setShowAuth(false); // 로그인 화면 닫기
      } catch {
        // 마이그레이션 실패 시 조용히 무시 (데이터는 로컬에 남아 있음)
      }
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);
}
